function calculatorESV(minZP, esvRate) {
  const percentage = document.querySelector('input[name="category1"]:checked');
  const salaryInput = document.querySelector('input.salary1');
  const salary = parseFloat(salaryInput.value);
  const category = percentage ? parseFloat(percentage.value) / 100 : 0;
  const esvMinSalary = minZP * esvRate;
  let n = 0;

  if (!isNaN(salary) && category > 0) {
    document.querySelectorAll('.percentage').forEach(el => {
      el.textContent = percentage.value;
    });

    if (salary > esvMinSalary) {
      n = esvMinSalary * category;
    } else if (salary <= esvMinSalary && salary >= minZP) {
      n = salary * category;
    } else if (salary < minZP) {
      if (percentage.dataset.main_worker === "1") {
        n = minZP * category;
      } else {
        n = salary * category;
      }
    }

    document.querySelectorAll('.esv').forEach(el => {
      el.textContent = n ? n.toFixed(2) : '0.00';
    });
  }
}

function fetchMinSalaryAndCalculate() {
  const salaryInput = document.querySelector('input.salary1');
  const salaryInputWrap = document.querySelector('.js--salary_field_wrap');

  if (!salaryInput.value.trim()) {
    salaryInput.classList.add('invalid');
    salaryInputWrap.classList.add('invalid');
    return;
  } else {
    salaryInput.classList.remove('invalid');
    salaryInputWrap.classList.remove('invalid');
  }

  fetch('/nsl-calculator/get-min-salary', {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
  })
      .then(response => response.json())
      .then(res => {
        if (res && res.length > 0) {
          calculatorESV(res[0].min_salary, res[0].esv_rate);
        }
      })
      .catch(() => {});
}

document.addEventListener('DOMContentLoaded', function () {
  const salaryInput = document.querySelector('input.salary1');
  const salaryInputWrap = document.querySelector('.js--salary_field_wrap');
  const submitButton = document.querySelector('.js--submit_calculator');
  if (submitButton) {
    submitButton.addEventListener('click', function (e) {
      e.preventDefault();
      fetchMinSalaryAndCalculate();
    });
  }

  if (salaryInput) {
    salaryInput.addEventListener('input', function() {
      if (this.value.trim()) {
        this.classList.remove('invalid');
        salaryInputWrap.classList.remove('invalid');
      }
    });
  }

});
